<template>
  <div id="main-content">
    <div style="display: flex;background: #FFFFFF;padding: 10px;cursor: pointer">
      <div class="my-group">
        <div class="my-group-item my-group-item-left" :class="type==='ad_spend'?'active':''" @click="type='ad_spend'">广告投放</div>
        <div class="my-group-item " :class="type==='ad_rebate'?'active':''" @click="type='ad_rebate'">广告返点</div>
        <div class="my-group-item" :class="type==='ad_cash'?'active':''" @click="type='ad_cash'">广告收入</div>
        <div class="my-group-item my-group-item-right" :class="type==='purchase'?'active':''"  @click="type='purchase'">内购收入</div>
      </div>
      <div class="my-year" >
        {{year}}年<a-icon type="down" />
        <div class="my-year-list">
          <div :class="i===3?'active':''"
            v-for="i in 5" @click="year=year+i-3">{{year+i-3}}</div>
        </div>
      </div>
      <div v-if="type==='purchase'" style="padding: 5px 10px;color: red">
        iOS：唯一时区&nbsp;&nbsp;&nbsp;&nbsp;Android：PDT时区
      </div>
      <div style="flex: 1"></div>
      <div class="my-button" @click="downloadReport()">
        下载
      </div>
    </div>
    <div class="gb-table-panel" style="margin-top: 10px;background: #FFFFFF;">
      <div class="gb-table-content" >
        <div class="gb-table-list" style="background: #E5E5E5;position: absolute;top:0px;">
          <div class="gb-table-item" style="width: 100px;">渠道</div>
          <div class="gb-table-item" >账户</div>
          <div class="gb-table-item" v-for="month in 12">{{month}}月</div>
        </div>
        <a-spin v-if="dataLoading" style="width: 100%;margin-top: 20px;"></a-spin>
        <div v-else class="gb-table-list" v-for="(dataItem,dataIndex) in  dataList">
          <div class="gb-table-item" style="width: 100px;">
            {{dataItem.name}}
            <a-tooltip style="cursor: pointer" v-if="type==='ad_cash'&&$store.state.RevenueChange[dataItem.name]">
              <template slot="title" >
                {{$store.state.RevenueChange[dataItem.name]}}
              </template>
              <a-icon type="info-circle" theme="filled" />
            </a-tooltip>
            </div>
          <div class="gb-table-item">
            <div style="display: flex;flex-flow: column;height: 100%;">
              <div style="border-bottom: 1px solid #FFFFFF;flex: 1;cursor: pointer" v-for="(dataItemItem,dataItemIndex) in dataItem.children">
                <a-tooltip>
                  <template slot="title" v-if="type==='purchase'">
                    {{$store.state.purchaseAccount[dataItemItem.name]}}
                  </template>
                  {{dataItemItem.name}}
                </a-tooltip>
              </div>
            </div>
          </div>
          <div class="gb-table-item" v-for="month in 12">
            <div style="display: flex;flex-flow: column;height: 100%;">
              <div style="border-bottom: 1px solid #FFFFFF;flex: 1;word-break:break-all" v-for="(dataItemItem,dataItemIndex) in dataItem.children">
                {{dataItemItem.children[month]?dataItemItem.children[month]:'&nbsp;'}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {GetSettlementMonthData, TestOutData} from "../../api/v1/home_api";
import axios from "axios";

export default {
  name: "Index",
  data(){
    return {
      type:'ad_spend',
      year:2022,
      dataList:{},
      dataLoading:false
    }
  },
  watch:{
    type:{
      handler:function (value,oldVal){
        this.initData()
      }
    },
    year:{
      handler:function (value,oldVal){
        this.initData()
      }
    }
  },
  mounted() {
    let date = new Date()
    this.year = date.getFullYear()
    this.initData()
  },
  methods:{
    initData(){
      if (this.dataLoading) return
      this.dataLoading = true
      this.dataList = {}
      GetSettlementMonthData({
        type:this.type,
        year:this.year
      }).then(resp => {
        this.dataLoading = false
        if (resp.code===200){
          this.dataList = resp.data
        }
      })
    },
    downloadReport(){
      // axios.create({
      //   baseURL:"https://datacenter.gamebrain.io/inner/purchase_base",
      //   params:{
      //     app_id:361,
      //     status:2,
      //     start:"2023-05-01"
      //   }
      // }).post().then(resp=>{
      //   let _name = "2023-05 鼠鼠 Android 内购 退款"
      //   var _data_list = resp.data.data
      //   var _data_field = [
      //     {
      //       dataIndex:'date',
      //       title:'退款日期（UTC）'
      //     },
      //     {
      //       dataIndex:'country',
      //       title:'国家'
      //     },
      //     {
      //       dataIndex:'sku',
      //       title:'SKU'
      //     },
      //     {
      //       dataIndex:'sku_title',
      //       title:'sku_title'
      //     },
      //     {
      //       dataIndex:'type',
      //       title:'类型（1内购，2订阅）'
      //     },
      //     {
      //       dataIndex:'order_id',
      //       title:'订单编号'
      //     },
      //     {
      //       dataIndex:'usd_money',
      //       title:'美金退款单价'
      //     },
      //     {
      //       dataIndex:'money',
      //       title:'分成后退款总价'
      //     },
      //     {
      //       dataIndex:'number',
      //       title:'退款笔数'
      //     },
      //   ]
      //   this._export_cvs(_data_list,_data_field,_name)
      // })
      // return
      let MapType = {
        'ad_cash':'广告收益',
        'ad_spend':'广告推广',
        'purchase':'内购',
        'ad_rebate':'广告返点',
      }
      let _name = MapType[this.type]
      _name += ' '+this.year+'年 DataCenter 结算核对'
      var _data_list = []
      var _data_field = [
        {
          dataIndex:'channel',
          title:'渠道'
        },
        {
          dataIndex:'account',
          title:'账户'
        },
      ]
      for (let _m=1;_m<=12;_m++){
        _data_field.push({
          dataIndex: _m+'M',
          title: _m+'月'
        })
      }
      Object.values(this.dataList).forEach(channel_item => {
        Object.values(channel_item.children).forEach(account_item => {
          let _data_item = {}
          Object.keys(account_item.children).forEach(month_key=>{
            _data_item[month_key+'M'] = account_item.children[month_key]
          })
          _data_item['channel'] = channel_item.name
          _data_item['account'] = account_item.name
          _data_list.push(_data_item)
        })
      })
      this._export_cvs(_data_list,_data_field,_name)
    }
  }
}
</script>

<style >

</style>



// WEBPACK FOOTER //
// src/views/Settlement/Index.vue